import { DIALOG_CONTENT } from '../constant/dialog.constant';
import { DeepPartial, Prettify } from '@core/util';
import { StaticProvider } from '@angular/core';

export type DialogContent = {
  dialogContent: keyof typeof DIALOG_CONTENT;
  dialogComponent: any;
};

export type DialogProviders = { providers?: StaticProvider[] };

export type ContentDialogData = DeepPartial<
  Prettify<
    {
      title: string;
      button: { close: DialogButton };
    } & DialogContent
  >
> &
  DialogProviders;

export type DialogButton = {
  label: string;
  hide: boolean;
};

export type ConfirmDialogData = DeepPartial<
  Prettify<
    {
      title: string;
      button: { close: DialogButton; cancel: DialogButton; confirm: DialogButton };
    } & DialogContent
  >
> &
  DialogProviders;

export type ErrorDialogData = Prettify<ContentDialogData> & DialogProviders;
